import React from 'react';
import PropTypes from 'prop-types';

/**
 * @description loader spinner state enum
 *
 * @default pending
 */
export const spinnerStates = {
  done: 'done',
  pending: 'pending',
  error: 'error',
};

/**
 * @description loader spinner position enum
 *
 * @default center
 */
export const spinnerPositions = {
  center: 'loader--center',
  absolute: 'loader--absolute',
  mini: 'loader--mini',
};

/**
 * @description Simple loader spinner
 *
 * @param {string} spinnerState loader state. Can be 'done', 'pending' or 'error'. Default 'pending'.
 * @param {string} spinnerPosition loader position. Can be 'center', 'absolute', 'mini'. Deafult 'center'
 * @param {object} style basic react inline style
 * @param {string} className class for styling component
 *
 * @usage <Loader /> // spinner at center of container
 *
 * @usage <Loader spinnerState={spinnerStates.done}/> // empty spinner/placeholder at center of container
 *
 * @usage <Loader spinnerState={spinnerStates.pending}  spinnerPosition={spinnerPositions.absolute} style={{left: 0}}/> // spinner at left border
 *
 * @usage <Loader spinnerState={spinnerStates.error} />
 */
class Loader extends React.Component {
  render() {
    const inlineStyle = {
      left: this.props.left,
    };

    switch (this.props.spinnerState) {
      case spinnerStates.done:
        return (
          <div
            style={this.props.style}
            className={`loader loader--done ${this.props.spinnerPosition} ${this.props.className}`}
          />
        );
      case spinnerStates.pending:
        return (
          <div
            style={this.props.style}
            className={`loader loader--pending ${this.props.spinnerPosition} ${this.props.className}`}
          />
        );
      case spinnerStates.error:
        return (
          // <div
          //   style={this.props.style}
          //   className={`loader loader--error ${this.props.spinnerPosition} ${this.props.className}`}
          // >
          //   !
          // </div>
          null
        );
      default:
        return <div></div>;
    }
  }
}

Loader.propTypes = {
  spinnerState: PropTypes.oneOf(Object.values(spinnerStates)),
  spinnerPosition: PropTypes.oneOf(Object.values(spinnerPositions)),
  className: PropTypes.string,
};

Loader.defaultProps = {
  spinnerState: spinnerStates.pending,
  spinnerPosition: spinnerPositions.center,
  className: '',
};

export default Loader;
